import { get, post } from '@/request/http'

// 获取项目任务列表
export const getTasks = (params) => get('/api/admin/gettasks', params)

//删除任务
export const deletetask = (params) => post('/api/admin/deletetask', params)

//添加任务
export const addtask = (params) => post('/api/admin/addtask', params)

//编辑任务
export const updatetask = (params) => post('/api/admin/updatetask', params)

//获取人员
export const getUsers = (params) => get('/api/admin/getusersbyproject', params)

//获取单个项目
export const getProjectbyid = (params) => get('/api/admin/getprojectbyid', params)

//检查是否有时间冲突
export const checkaddupdate = (params) => get('/api/admin/checkaddupdate', params)



// WEBPACK FOOTER //
// ./src/api/myproject.js